var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAimsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7981 4.82515V11.3063C16.7981 11.7618 16.4309 12.1289 15.9815 12.1289H14.3291C13.8769 12.1289 13.5097 11.7618 13.5097 11.3063V4.82515C13.5097 4.3697 13.8769 3.99982 14.3291 3.99982H15.9815C16.4309 3.99982 16.7981 4.3697 16.7981 4.82515Z",
    fill: "#28B8AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.489 4.82515V11.3063C34.489 11.7618 34.1218 12.1289 33.6724 12.1289H32.02C31.5678 12.1289 31.2006 11.7618 31.2006 11.3063V4.82515C31.2006 4.3697 31.5678 3.99982 32.02 3.99982H33.6724C34.1218 3.99982 34.489 4.3697 34.489 4.82515Z",
    fill: "#28B8AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 9.39125V42.3493C42 43.263 41.2656 44 40.3585 44H7.63873C6.73441 44 6 43.263 6 42.3493V9.39125C6 8.47758 6.73441 7.74058 7.63873 7.74058H11.3163V11.3041C11.3163 12.9769 12.6673 14.3377 14.3279 14.3377H15.9804C17.641 14.3377 18.9893 12.9769 18.9893 11.3041V7.74058H29.008V11.3041C29.008 12.9769 30.359 14.3377 32.0196 14.3377H33.6721C35.33 14.3377 36.681 12.9769 36.681 11.3041V7.74058H40.3585C41.2656 7.74058 42 8.47758 42 9.39125Z",
    fill: "url(#paint0_linear_2429_25711)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.728 29.6851H17.2192L15.9557 25.3878L14.728 29.6851ZM18.536 34.525L17.86 32.123H14.0873L13.4469 34.525H9.81676L14.1586 22.1034H17.9488L22.2908 34.525H18.536Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6808 34.5222V26.8535L32.546 31.6912H29.5401L27.4054 26.8535V34.5222H24.4527V22.1055H28.099L31.0876 28.8423L34.1116 22.1055H37.6335V34.5222H34.6808Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2429_25711",
    x1: 48,
    y1: -3.48042,
    x2: 14.4808,
    y2: 52.9953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28B8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006D5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAimsLogo);
export default __webpack_public_path__ + "static/media/aims_logo.92ff6899b880a13595c8216f97b05d61.svg";
export { ForwardRef as ReactComponent };